
  export default {
    computed: {
      categories () {
        return this.$store.getters['blog/getCategories'];
      },
      currentCategory () {
        return this.$route.params.category;
      },
      homePath () {
        if (this.type === 'article') {
          return '/blog/';
        } else if (this.type === 'guide') {
          return '/guides/';
        }
        return '/videos/';
      },
      meta () {
        return this.$store.getters['blog/getMeta'];
      },
      type () {
        return this.meta.type;
      }
    },
    methods: {
      isCurrent (category) {
        return this.currentCategory === category.title;
      }
    }
  };
